import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';


import Homepage from './pages/Homepage';
import './App.css';

// ScrollToTop
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// GAHandler


const App = () => {


  return (
    <>
      <ScrollToTop />




      <Routes>
        <Route path="/" element={<Homepage />} />

 
      </Routes>
    </>
  );
};

export default App;